<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>东进防控工会开展2023年“夏送清凉”慰问活动</h2>
        <p>
          近日，受台风“卡努”及其外围环流影响，高温炎热仍在持续。为进一步做好高温天气防范应对工作，切实保障一线员工生产生活安全，东进防控工会结合职责职能，主动作为，开展了2023年“夏送清凉”慰问活动。8月2日下午，东进防控工会主席张雪婷和副主席肖彪亲自带队先后前往同沙驿站、美东大厦等地，看望慰问一线员工，为他们送去一份清凉和工会关爱。
        </p>
        <p>
          在同沙驿站，张雪婷和肖彪亲自将一件件防暑降温用品分发到一线员工的手中，向他们表示亲切的慰问，鼓励他们继续发扬劳模精神、劳动精神、工匠精神，立足自身岗位踏实工作，为企业发展作出更大贡献，并再三叮嘱一线员工，在高温作业时，一定要注意防暑降温，确保自身的健康和安全。
        </p>
        <img width="100%" :src="img[0]" alt="">
        <img width="100%" :src="img[1]" alt="">
        <p>
          随后，张雪婷和肖彪马不停蹄地赶往美东大厦，同时港口服务部经理杨超一同参与“夏送清凉”慰问活动。
        </p>
        <img width="100%" :src="img[2]" alt="">
        <img width="100%" :src="img[3]" alt="">
        <p>
          夏日送清凉，关爱沁人心，防暑降温是一项季节性很强的劳动保护工作，直接关系到职工身体健康和企业生产安全。东进防控工会还将严格按照有关规定，落实防暑降温主体责任，合理安排作业时间，及时发放高温津贴，为一线员工解难题、办实事，拓展工会服务的广度、深度，努力保障一线员工的身心健康，不断增强一线员工的获得感、幸福感、安全感。
        </p>
      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News8'})">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;东进公司开展消防...</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({name: 'News6'})">防控知识宣传...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>

      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news7.png'), require('@/assets/news7-1.png'), require('@/assets/news7-2.png'), require('@/assets/news7-3.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        margin: 20px 0;
        text-align: center;
        font-size: 24px;
      }

      p {
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        font-size: 16px;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  }
</style>
